import { MatomoTracker as Matomo } from '@canvasflow/analytics';
import {
	Tracker,
	TrackingEvent,
	TrackerLogger,
	TrackingData,
} from '../Tracking.events';
import config from '@config';

export class MatomoTracker implements Tracker {
	matomo: Matomo;
	constructor(matomo: Matomo) {
		TrackerLogger.info(
			`Matomo running with site id:`,
			config.analytics?.matomo?.siteId,
		);
		this.matomo = matomo;
	}

	sendEvent(event: TrackingEvent) {
		TrackerLogger.debug(`Event in matomo:`, event);
		const { type } = event;
		switch (type) {
			case 'INSTALLED':
				this.onInstalled();
				break;
			case 'LOGIN':
				this.onLogin();
				break;
			case 'OPEN_TOC':
				this.onOpenToc();
				break;
			case 'CLOSE_TOC':
				this.onCloseToc();
				break;
			case 'SHARE':
				this.onShare(event.data);
				break;
			case 'BTN_CLICK_INSTALL':
				this.onClickInstall();
				break;
			case 'BTN_CLICK_LOGIN':
				this.onClickLogIn();
				break;
			case 'BTN_CLICK_LOGOUT':
				this.onClickLogOut();
				break;
			case 'BTN_CLICK_RESPONSIVE':
				this.onClickResponsive(event.data);
				break;
			case 'BTN_CLICK_REPLICA':
				this.onClickReplica(event.data);
				break;
			case 'BTN_CLICK_REPLICA_SINGLE':
				this.onClickReplicaSingle(event.data);
				break;
			case 'BTN_CLICK_REPLICA_DOUBLE':
				this.onClickReplicaDouble(event.data);
				break;
			case 'BTN_CLICK_FAVORITE_ARTICLE':
				this.onClickFavoriteArticle(event.data);
				break;
			case 'BTN_CLICK_UNFAVORITE_ARTICLE':
				this.onClickUnfavoriteArticle(event.data);
				break;
			case 'BTN_CLICK_ISSUE':
				this.onClickIssue(event.data);
				break;
			case 'LANGUAGE_CHANGE':
				this.onChangeLanguage(event.data);
				break;
			default:
				return;
		}
	}

	private onInstalled() {
		this.matomo.trackEvent({
			category: 'app',
			action: 'installed',
			name: 'App is installed',
		});
	}

	private onLogin() {
		this.matomo.trackEvent({
			category: 'session',
			action: 'login',
			name: 'User logged in',
		});
	}

	private onOpenToc() {
		this.matomo.trackEvent({
			category: 'issue',
			action: 'open_toc',
			name: 'Open TOC',
		});
	}

	private onCloseToc() {
		this.matomo.trackEvent({
			category: 'issue',
			action: 'close_toc',
			name: 'Close TOC',
		});
	}

	private onShare(_data: TrackingData) {
		// TODO: Need to confirm the category, action and name for matomo events
		// this.matomo.trackEvent({
		// 	category: '',
		// 	action: '',
		// 	name: '',
		// });
		// this.gtag('event', 'share', {
		// 	method: data?.method,
		// 	content_type: data?.contentType,
		// 	item_id: data?.article?.ArticleID,
		// });
	}

	private onClickInstall() {
		this.matomo.trackEvent({
			category: 'session',
			action: 'click_install',
			name: 'Click install    ',
		});
	}

	private onClickLogIn() {
		this.matomo.trackEvent({
			category: 'session',
			action: 'login',
			name: 'Click login',
		});
	}

	private onClickLogOut() {
		this.matomo.trackEvent({
			category: 'session',
			action: 'logout',
			name: 'Click logout',
		});
	}

	private onClickResponsive(_data: TrackingData) {
		this.matomo.trackEvent({
			category: 'issue',
			action: 'click_responsive',
			name: 'Click Responsive',
		});
	}

	private onClickReplica(_data: TrackingData) {
		this.matomo.trackEvent({
			category: 'issue',
			action: 'click_replica',
			name: 'Click Replica',
		});
	}

	private onClickReplicaSingle(_data: TrackingData) {
		this.matomo.trackEvent({
			category: 'issue',
			action: 'replica_single',
			name: 'Click Single Page Replica',
		});
	}

	private onClickReplicaDouble(_data: TrackingData) {
		this.matomo.trackEvent({
			category: 'issue',
			action: 'replica_double',
			name: 'Click Double Page Replica',
		});
	}

	private onClickFavoriteArticle(_data: TrackingData) {
		this.matomo.trackEvent({
			category: 'article',
			action: 'favorie_article',
			name: 'Click Favorite Article',
		});
	}

	private onClickUnfavoriteArticle(_data: TrackingData) {
		this.matomo.trackEvent({
			category: 'article',
			action: 'unfavorie_article',
			name: 'Click Unfavorite Article',
		});
	}

	private onClickIssue(_data: TrackingData) {
		this.matomo.trackEvent({
			category: 'Navigation',
			name: 'click issue',
			action: 'click_issue',
			// customDimensions: [{ id: 1, value: 'paid' }],
		});
	}

	private onChangeLanguage(_data: TrackingData) {
		this.matomo.trackEvent({
			category: 'article',
			action: 'change_language',
			name: 'Change Language',
		});
	}
}
